import { 
    ACTUALIZAR_LIST_NIVEL4,
    AGREGAR_NIVEL4,
  } from "./nivel4Actions";

  const nivel4Reducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_NIVEL4: {
            return {
                ...state,
                nivel4List: action.payload
            }
        };

        case AGREGAR_NIVEL4:{
            return {
                 ...state,
                 nivel4List: [action.payload, ...state.nivel4List]
             }
         };

        default:
            return state;

    }
  }

  export default nivel4Reducer;